import React from 'react'
// import styled from 'styled-components'

// import { FixedSpaceColumn } from 'lib-components/layout/flex-helpers'
import type { CitizenCustomizations} from 'lib-customizations/types'

import { citizenConfig } from './appConfigs'
import MunicipalityLogo from './assets/municipality-logo-primary.svg'
import featureFlags from './featureFlags'
import mapConfig from './mapConfig'
import { H1, H2, H3, P } from 'lib-components/typography'
import ExternalLink from 'lib-components/atoms/ExternalLink'
import colors from 'lib-customizations/common'

// const MultiLineCheckboxLabel = styled(FixedSpaceColumn).attrs({
//   spacing: 'zero'
// })`
//   margin-top: -6px;
// `

const customizations: CitizenCustomizations = {
  appConfig: citizenConfig,
  langs: ['fi', 'sv', 'en'],
  translations: {
    fi: {
      header: {
        lang: {
          fi: 'Suomeksi',
          sv: 'På svenska',
          en: 'In English'
        },
        langMobile: {
          fi: 'Suomeksi',
          sv: 'På svenska',
          en: 'English'
        },
      },
      footer: {
        cityLabel: '© Kauniaisten kaupunki',
        privacyPolicyLink: (
          <a
            href="https://www.kauniainen.fi/tietosuoja/tietosuojaselosteet-ja-rekisteriselosteet/"
            data-qa="footer-policy-link"
            style={{ color: colors.main.m2 }}
          >
            Tietosuojaselosteet
          </a>
        ),
        sendFeedbackLink: (
          <a
            href="https://www.kauniainen.fi/varhaiskasvatus-ja-koulutus/varhaiskasvatusyksikot/"
            data-qa="footer-feedback-link"
            style={{ color: colors.main.m2 }}
          >
            Lähetä palautetta
          </a>
        ),
      },
      loginPage: {
        title: 'Kauniaisten kaupungin varhaiskasvatus',
        login: {
          infoBoxText: (
            <>
            <P>
              Mikäli kirjautuminen ei onnistu, voit olla yhteydessä sähköpostiosoitteeseen{' '}
              <a href="mailto:kauniainen@kauniainen.fi">kauniainen@kauniainen.fi</a>
              . Voit kirjautua myös käyttämällä vahvaa tunnistautumista.
          </P>
            </>
          ),
        },
      },
      map: {
        mainInfo:
          "Tässä näkymässä voit hakea kartalta Kauniaisten varhaiskasvatus-, esiopetus- ja kerhopaikkoja.",
        serviceVoucherLink:
          'https://www.kauniainen.fi/varhaiskasvatus-ja-koulutus/varhaiskasvatusyksikot/yksityinen-varhaiskasvatus/palveluseteli/',
        privateUnitInfo: (
          <span>
            Yksityinen varhaiskasvatus | Kauniainen{' '}
            <ExternalLink
              text="täältä."
              href="https://www.kauniainen.fi/varhaiskasvatus-ja-koulutus/varhaiskasvatusyksikot/yksityinen-varhaiskasvatus/"
              newTab
            />
          </span>
        ),
      },
      applications: {
        creation: {
          preschoolLabel:
            'Ilmoittautuminen esiopetukseen.',
          preschoolDaycareInfo:
            'Tällä lomakkeella voit myös hakea liittyvää varhaiskasvatusta lapsille, jotka ilmoitetaan / on ilmoitettu esiopetukseen.',
          preschoolInfo: (
            <>
              <P>
              Maksutonta esiopetusta on neljä tuntia päivässä. Tämän lisäksi lapselle voidaan hakea maksullista liittyvää varhaiskasvatusta,
              jota tarjotaan esiopetuspaikoissa aamulla ennen esiopetuksen alkua ja iltapäivisin esiopetuksen jälkeen.{' '}
                <a href='https://www.kauniainen.fi/varhaiskasvatus-ja-koulutus/esiopetus/'>
                  https://www.kauniainen.fi/varhaiskasvatus-ja-koulutus/esiopetus/</a>
              </P>
            </>
          ) as unknown as string,
          transferApplicationInfo: {
            DAYCARE:
              'Lapsella on jo paikka Kauniaisten varhaiskasvatuksessa. Tällä hakemuksella voit hakea siirtoa toiseen varhaiskasvatusta tarjoavaan yksikköön Kauniaisissa.',
          },
          applicationInfo: (
            <P>
              Voit muokata hakemustasi niin kauan, kun sitä ei vielä ole otettu käsittelyyn. Sen jälkeen voit muokata hakemustasi tai
              perua sen olemalla yhteydessä varhaiskasvatuksen palveluohjaukseen, puh. 050 3636 343
            </P>
          )
        },
        editor: {
          unitPreference: {
            units: {
              serviceVoucherLink:
              'https://www.kauniainen.fi/varhaiskasvatus-ja-koulutus/varhaiskasvatusyksikot/yksityinen-varhaiskasvatus/palveluseteli/',
            },
          },
          heading: {
            info: {
              DAYCARE: (
                <>
                  <P>
                    Varhaiskasvatusta voi hakea ympäri vuoden. Hakemus on jätettävä
                    viimeistään neljä kuukautta ennen kuin tarvitsette paikan.
                    Mikäli tarvitsette varhaiskasvatusta kiireellisesti työn tai
                    opiskelujen vuoksi, tulee paikkaa hakea viimeistään kaksi
                    viikkoa ennen.
                  </P>
                  <P>
                    Saatte kirjallisen päätöksen varhaiskasvatuspaikasta{' '}
                    <a
                      href="https://www.suomi.fi/viestit"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Suomi.fi-viestit
                    </a>{' '}
                    -palveluun tai postitse, mikäli et ole ottanut Suomi.fi
                    -palvelua käyttöön.
                  </P>
                  <P>
                    Kunnallisen varhaiskasvatuksen asiakasmaksut ja palvelusetelin
                    omavastuuosuus määräytyvät prosenttiosuutena perheen
                    bruttotuloista. Tulojen lisäksi maksuihin vaikuttaa perheen koko
                    ja sovittu varhaiskasvatusaika. Palveluseteliyksiköissä voidaan
                    periä lisämaksu, tiedot mahdollisesta lisämaksusta löytyy
                    yksikön nettisivuilta. Perhe toimittaa tuloselvityksen
                    bruttotuloistaan viimeistään kahden viikon kuluessa siitä, kun
                    lapsi on aloittanut varhaiskasvatuksessa.
                  </P>
                  <P>
                    Lisätietoa varhaiskasvatuksen maksuista, tuloselvityksen
                    toimittamisesta ja palvelusetelin lisämaksusta löydät täältä:{' '}
                    <a href="https://www.kauniainen.fi/varhaiskasvatus-ja-koulutus/varhaiskasvatusyksikot/kunnallinen-varhaiskasvatus/maksut/">
                      Maksut varhaiskasvatuksessa
                    </a>
                    {' '}ja{' '}
                    <a href="https://www.kauniainen.fi/varhaiskasvatus-ja-koulutus/varhaiskasvatusyksikot/yksityinen-varhaiskasvatus/palveluseteli/">
                      lisätietoa palvelusetelistä
                    </a>
                    .
                  </P>
                  <P fitted={true}>* Tähdellä merkityt tiedot ovat pakollisia</P>
                </>
              ),
              PRESCHOOL: (
                <>
                  <P>
                  Esiopetukseen osallistutaan oppivelvollisuuden alkamista edeltävänä vuonna.
                  Esiopetus on maksutonta. Lisätietoja:{' '}
                  <a href='https://www.kauniainen.fi/varhaiskasvatus-ja-koulutus/esiopetus/'>https://www.kauniainen.fi/varhaiskasvatus-ja-koulutus/esiopetus/</a>
                  </P>
                  <P>
                    Päätökset tulevat{' '}
                    <a
                      href="https://www.suomi.fi/viestit"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Suomi.fi-viestit
                    </a>{' '}
                    -palveluun tai postitse, mikäli et ole ottanut Suomi.fi
                    -palvelua käyttöön.
                  </P>
                  <P fitted={true}>* Tähdellä merkityt tiedot ovat pakollisia</P>
                </>
              ),
            },
          },
          actions: {
            allowOtherGuardianAccess: (
              <span>
                Ymmärrän, että tieto hakemuksesta menee myös lapsen toiselle huoltajalle.
                Ole tarvittaessa yhteydessä palveluohjaukseen. Palveluohjauksen yhteystiedot
                löydät täältä: {' '}
                <a
                  href="https://www.kauniainen.fi/varhaiskasvatus-ja-koulutus/varhaiskasvatusyksikot/kunnallinen-varhaiskasvatus/hakeminen/"
                  target="_blank"
                  rel="noreferrer"
                >
                  täältä
                </a>
                .
              </span>
            ),
          },
          serviceNeed: {
            startDate: {
              info: {
                PRESCHOOL: [
                  'Maksuton esiopetus alkaa 7.8.2025'
                ],
              },
            },
            urgent: {
              attachmentsMessage: {
                text: (
                  <>
                    <P fitted={true}>
                      Mikäli varhaiskasvatuspaikan tarve johtuu äkillisestä
                      työllistymisestä tai opiskelusta, tulee paikkaa hakea
                      viimeistään <strong>kaksi viikkoa ennen</strong> kuin tarve
                      alkaa. Hakemuksen{' '}
                      <strong>liitteenä tulee olla työ- tai opiskelutodistus</strong>{' '}
                      molemmilta samassa taloudessa asuvilta huoltajilta.
                      Suosittelemme toimittamaan liitteen sähköisesti tässä, sillä
                      kahden viikon käsittelyaika alkaa siitä, kun olemme
                      vastaanottaneet hakemuksen tarvittavine liitteineen. Jos et voi
                      lisätä liitteitä hakemukselle sähköisesti,
                      lähetä ne sähköpostilla kauniainen@kauniainen.fi
                    </P>
                    <P>
                      Palveluntarve on lapselle viikottain varattava varhaiskasvatusaika. Ilmoita haluttu varhaiskasvatuksen palveluntarve kohdassa "Muut lisätiedot" ja valitse siihen jokin seuraavista:
                      <ul>
                        <li>
                          enintään 25 tuntia / viikko
                        </li>
                        <li>
                          25-35 tuntia / viikko
                        </li>
                        <li>
                          yli 35 tuntia / viikko
                        </li>
                      </ul>
                    </P>
                  </>
                ),
              }
            },
            dailyTime: {
              connectedDaycareInfo: (
                <>
                  <P>
                    Voit hakea lapselle tarvittaessa{' '}
                    <strong>
                      esiopetukseen lisäksi täydentävää varhaiskasvatusta, joka on
                      maksullista.
                    </strong>{' '}
                    Täydentävää varhaiskasvatusta järjestetään aamuisin ennen esiopetusta
                    ja esiopetuksen jälkeen päiväkodin aukioloaikojen mukaisesti.
                  </P>
                  <P>
                    Saat varhaiskasvatuspaikasta erillisen kirjallisen päätöksen.
                    Päätös tulee{' '}
                    <a
                      href="https://www.suomi.fi/viestit"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Suomi.fi-viestit
                    </a>{' '}
                    -palveluun tai postitse, mikäli et ole ottanut Suomi.fi-viestit
                    -palvelua käyttöön.
                  </P>
                </>
              ),
            },
          },
          fee: {
            links: (
              <>
              <P>
                Lisätietoa varhaiskasvatuksen maksuista, palvelusetelin lisämaksusta
                ja tuloselvityslomakkeen löydät täältä:
                <br />
                <a
                  href="https://www.kauniainen.fi/varhaiskasvatus-ja-koulutus/varhaiskasvatusyksikot/kunnallinen-varhaiskasvatus/maksut/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Maksut varhaiskasvatuksessa
                </a>
              </P>
              <P>
                <a
                  href="https://www.kauniainen.fi/varhaiskasvatus-ja-koulutus/varhaiskasvatusyksikot/yksityinen-varhaiskasvatus/palveluseteli/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Lisätietoa palvelusetelistä
                </a>
              </P>
              </>
            )
          },
          contactInfo: {
            futureAddressInfo:
              "Kauniaisten varhaiskasvatuksessa virallisena osoitteena pidetään väestötiedoista saatavaa osoitetta. Osoite väestötiedoissa muuttuu hakijan tehdessä muuttoilmoituksen postiin tai maistraattiin.",
          },
        },
      },
      decisions: {
        assistancePreschoolDecisions: {
          appealInstructions: (
            <>
              <P>
                Tähän päätökseen tyytymätön voi tehdä kirjallisen
                oikaisuvaatimuksen. Päätökseen ei saa hakea muutosta valittamalla
                tuomioistuimeen.
              </P>

              <H3>Oikaisuvaatimusoikeus</H3>
              <P>
                Oikaisuvaatimuksen saa tehdä se, johon päätös on kohdistettu tai
                jonka oikeuteen, velvollisuuteen tai etuun päätös välittömästi
                vaikuttaa (asianosainen).
              </P>

              <H3>Oikaisuvaatimusaika</H3>
              <P>
                Oikaisuvaatimus on tehtävä 30 päivän kuluessa päätöksen
                tiedoksisaannista.
              </P>
              <P>
                Oikaisuvaatimus on toimitettava kirjaamoon määräajan viimeisenä
                päivänä ennen kirjaamon aukioloajan päättymistä.
              </P>
              <P>
                Asianosaisen katsotaan saaneen päätöksestä tiedon seitsemäntenä päivänä
                kirjeen lähettämisest jollei muuta näytetä, saantitodistuksen osoittamana
                aikana tai erilliseen tiedoksiantotodistukseen merkittynä aikana.
              </P>
              <P>
                Käytettäessä tavallista sähköistä tiedoksiantoa katsotaan asianosaisen saanee tiedon päätöksestä kolmantena
                päivänä viestin lähettämisestä, jollei muuta näytetä.
              </P>
              <P>
                Tiedoksisaantipäivää ei lueta oikaisuvaatimusaikaan. Jos oikaisuvaatimusajan viimeinen päivä on pyhäpäivä,
                itsenäisyyspäivä, vapunpäivä, joulu- tai juhannusaatto tai arkilauantai, saa oikaisuvaatimuksen tehdä ensimmäisenä
                arkipäivänä sen jälkeen.
              </P>

              <H3>Oikaisuviranomainen</H3>
              <P>
                Oikaisuvaatimus osoitetaan päätöksen tehneelle viranhaltijalle ja toimitetaan osoitteeseen:
              </P>
              <P>
                Suomenkielinen kasvatus- ja koulutusvaliokunta
                <br />
                Kauniaistentie 10, Faksi: 09 5056 535, PL 52, 02701 KAUNIAINEN
                <br />
                Kauniaisten kaupunki sähköposti: kirjaamo@kauniainen.fi
                <br />
                Kirjaamo Puh. 09 50561
                <br />
                Kirjaamon aukioloaika: klo 8.00–15.45
              </P>
              <H3>Oikaisuvaatimuksen muoto ja sisältö</H3>
              <P>
              Oikaisuvaatimus on tehtävä kirjallisesti. Myös sähköinen asiakirja täyttää
              vaatimuksen kirjallisesta muodosta. Oikaisuvaatimuksessa on ilmoitettava:
              </P>
              <ul>
                <li>
                  oikaisuvaatimuksen tekijän nimi, kotikunta, postiosoite, puhelinnumero
                  ja muut tarvittavat yhteystiedot-päätös, johon haetaan oikaisua
                </li>
                <li>
                  miltä kohdin päätökseen haetaan oikaisua ja millaista oikaisua siihen vaaditaan
                  tehtäväksi - perusteet, joilla oikaisua vaaditaan
                </li>
                <li>sähköpostiosoite, jos oikaisuvaatimusviranomaisen päätös saadaan antaa tiedoksi sähköisenä viestinä.</li>
              </ul>
              <P>
                Jos oikaisuvaatimuksen tekijän puhevaltaa käyttää hänen laillinen edustajansa tai asiamiehensä jos
                oikaisuvaatimuksen laatijana on joku muu henkilö, oikaisuvaatimuksessa on ilmoitettava myös tämän nimi, kotikunta
                ja postiosoite.
              </P>
              <P>
                Asiamiehen on tarvittaessa esitettävä valtakirja. Sähköistä asiakirjaa ei kuitenkaan tarvitse täydentää
                allekirjoituksella, jos asiakirjassa on tiedot lähettäjästä eikä asiakirjan alkuperäisyyttä tai eheyttä
                on syytä epäillä.
              </P>
              <P noMargin>Oikaisuvaatimukseen on liitettävä</P>
              <ul>
                <li>
                  päätös, johon haetaan oikaisua, alkuperäisenä tai jäljennöksenä
                </li>
                <li>
                  selvitys oikaisuvaatimusajan alkamisen ajankohdasta
                </li>
                <li>
                asiakirjat, joihin oikaisuvaatimuksen tekijä vetoaa vaatimuksensa tueksi,
                jollei niitä ole jo aikaisemmin toimitettu viranomaiselle.
                </li>
              </ul>
            </>
          )
        },
        assistanceDecisions: {
          decision: {
            appealInstructions: (
              <>
                <H3>Oikaisuvaatimusoikeus</H3>
                <P>
                  Oikaisuvaatimuksen saa tehdä se, johon päätös on kohdistettu tai jonka oikeuteen,
                  velvollisuuteen tai etuun päätös välittömästi vaikuttaa (asianosainen).
                </P>
                <H3>Oikaisuvaatimusaika</H3>
                <P>
                  Oikaisuvaatimus on tehtävä 30 päivän kuluessa päätöksen tiedoksisaannista.
                </P>
                <H3>Tiedoksisaanti</H3>
                <P>
                  Kirjeen lähettämisestä seitsemän päivän kuluttua / Saantitodistukseen tai
                  tiedoksiantotodistukseen merkittynä päivänä / Sähköisen viestin lähettämisestä kolmantena
                  päivänä
                </P>
                <P>
                  Jos määräajan viimeinen päivä on pyhäpäivä / itsenäisyyspäivä / vapunpäivä / joulu- tai
                  juhannusaatto / arkilauantai, saa tehtävän toimittaa ensimmäisenä arkipäivänä sen jälkeen.
                </P>
                <H3>Oikaisuviranomainen</H3>
                <P>Oikaisu tehdään Etelä-Suomen aluehallintovirastolle. Oikaisuvaatimuksen voi tehdä sähköisenä / postitse.</P>
                <P>
                Oikaisuvaatimus voi tehdä myös aluehallintoviraston sähköisellä lomakkeella, jokalöytyy
                   <a href='https://www.suomi.fi/palvelut/verkkoasiointi/oikaisuvaatimus-
                  varhaiskasvatus-opetus-ja-koulutus-aluehallintovirasto/d7022cad-
                  9ecd-4dad-84ec-17489d260a8d'>Suomi.fi-palvelussa</a>
                  <br />
                  Etelä-Suomen aluehallintovirasto
                  <br />
                  Postiosoite: PL 1, 13035 AVI
                  <br />
                  Käyntiosoite: Ratapihantie 9, 00521 Helsinki
                  <br />
                  Sähköposti: kirjaamo.etela@avi.fi
                  <br />
                  Puhelin: 0295 016 000
                  <br />
                  Fax: 0295 016 661
                  <br />
                  Virastoaika: ma-pe 8.00–16.15
                </P>
                <H3>Oikaisuvaatimuksen muoto ja sisältö</H3>
                <P>
                  Oikaisuvaatimus on tehtävä kirjallisesti. Myös sähköinen asiakirja
                  täyttää vaatimuksen kirjallisesta muodosta.
                </P>
                <P noMargin>
                  Oikaisuvaatimuksessa on ilmoitettava:
                </P>
                <ul>
                  <li>Tekijän nimi, kotikunta, postiosoite, puhelinnumero ja muut yhteystiedot</li>
                  <li>
                  Päätös, johon haetaan oikaisua
                  </li>
                  <li>
                    Miltä osin päätökseen haetaan oikaisua ja mitä oikaisua siihen vaaditaan tehtäväksi /
                    Vaatimuksen perusteet
                  </li>
                </ul>
                <P noMargin>Oikaisuvaatimukseen on liitettävä</P>
                <ul>
                  <li>
                    Päätös, johon haetaan oikaisua, alkuperäisenä tai jäljennöksenä
                  </li>
                  <li>
                    Todistus tiedoksisaannista tai
                    muu selvitys oikaisuvaatimusajan alkamisen ajankohdasta
                  </li>
                  <li>
                  Asiakirjat, joihin vetoat, jollei niitä
                  ole jo aikaisemmin toimitettu viranomaiselle
                  </li>
                </ul>
                <H3>Oikaisuvaatimuksen toimittaminen</H3>
                <P>
                  Oikaisuvaatimuskirjelmä on toimitettava oikaisuvaatimusajan kuluessa
                  oikaisuvaatimusviranomaiselle. Kirjelmän tulee olla perillä oikaisuvaatimusajan viimeisenä
                  päivänä ennen viraston aukiolon päättymistä.
                  Postitse / Sähköisesti tapahtuva lähettäminen on lähettäjän vastuulla.
                </P>
              </>
            )
          },
        }
      },
      income: {
        description: (
          <>
            <P>
              Tällä sivulla voit lähettää selvitykset varhaiskasvatusmaksuun
              vaikuttavista omista ja lastesi tuloista. Voit myös tarkastella
              palauttamiasi tuloselvityksiä ja muokata tai poistaa niitä, kunnes
              viranomainen on käsitellyt tiedot. Lomakkeen käsittelyn jälkeen voit
              päivittää tulotietojasi toimittamalla uuden lomakkeen.
            </P>
            <P>
              Kunnallisen varhaiskasvatuksen asiakasmaksut määräytyvät
              prosenttiosuutena perheen bruttotuloista. Maksut vaihtelevat perheen
              koon ja tulojen sekä varhaiskasvatusajan mukaan. Maksun määräämistä
              varten tulee toimittaa perheen tulotiedot viimeistään kahden viikon
              kuluessa varhaiskasvatuksen alkamisesta. Mikäli perhe ei toimita tulotietoja,
              maksuksi määrätään enimmäismaksu.
            </P>
            <P>
              Lisätietoja maksuista:{' '}
              <a href="https://www.kauniainen.fi/varhaiskasvatus-ja-koulutus/varhaiskasvatusyksikot/kunnallinen-varhaiskasvatus/maksut/">
                Maksut varhaiskasvatuksessa
              </a>
            </P>
         </>
        ),
        formDescription: (
          <>
            <P>
              <strong>Varhaiskasvatuksen asiakasmaksu</strong> on kiinteä kuukausimaksu,
              joka määräytyy perheen tulojen ja perheenjäsenten lukumäärän mukaan.
              Maksua määrättäessä perheeksi katsotaan yhteistaloudessa avioliitossa
              tai avioliitonomaisissa olosuhteissa elävät henkilöt sekä molempien
              samassa taloudessa asuvat alaikäiset lapset.
            </P>
            <P>
            Lisätietoa asiakasmaksuista:{' '}
              <a
                target="_blank"
                rel="noreferrer"
                href="https://www.kauniainen.fi/varhaiskasvatus-ja-koulutus/varhaiskasvatusyksikot/kunnallinen-varhaiskasvatus/maksut/"
              >
                tästä
              </a>
              .
            </P>
            <P>* Tähdellä merkityt tiedot ovat pakollisia</P>
          </>
        ),
      },
      accessibilityStatement: (
        <>
          <H1>Saavutettavuusseloste</H1>
          <P>
            Tämä saavutettavuusseloste koskee Kauniaisten kaupungin varhaiskasvatuksen
            eVaka-verkkopalvelua osoitteessa{' '}
            <a href="https://evaka.kauniainen.fi">evaka.kauniainen.fi</a>.
            Kauniaisten kaupunki pyrkii takaamaan verkkopalvelun saavutettavuuden,
            parantamaan käyttäjäkokemusta jatkuvasti ja soveltamaan asianmukaisia
            saavutettavuusstandardeja.
          </P>
          <P>
            Palvelun saavutettavuuden on arvioinut palvelun kehitystiimi, ja seloste
            on laadittu 12.4.2022.
          </P>
          <H2>Palvelun vaatimustenmukaisuus</H2>
          <P>
            Verkkopalvelu täyttää lain asettamat kriittiset
            saavutettavuusvaatimukset WCAG v2.1 -tason AA mukaisesti. Palvelu ei ole
            vielä kaikilta osin vaatimusten mukainen.
          </P>
          <H2>Toimet saavutettavuuden tukemiseksi</H2>
          <P>
            Verkkopalvelun saavutettavuus varmistetaan muun muassa seuraavilla
            toimenpiteillä:
          </P>
          <ul>
            <li>
              Saavutettavuus huomioidaan alusta lähtien suunnitteluvaiheessa, mm.
              valitsemalla palvelun värit ja kirjaisinten koot saavutettavasti.
            </li>
            <li>
              Palvelun elementit on määritelty semantiikaltaan johdonmukaisesti.
            </li>
            <li>Palvelua testataan jatkuvasti ruudunlukijalla.</li>
            <li>
              Erilaiset käyttäjät testaavat palvelua ja antavat saavutettavuudesta
              palautetta.
            </li>
            <li>
              Sivuston saavutettavuudesta huolehditaan jatkuvalla valvonnalla
              tekniikan tai sisällön muuttuessa.
            </li>
          </ul>
          <P>
            Tätä selostetta päivitetään sivuston muutosten ja saavutettavuuden
            tarkistusten yhteydessä.
          </P>
          <H2>Tunnetut saavutettavuusongelmat</H2>
          <P>
            Käyttäjät saattavat edelleen kohdata sivustolla joitakin ongelmia.
            Seuraavassa on kuvaus tunnetuista saavutettavuusongelmista. Jos huomaat
            sivustolla ongelman, joka ei ole luettelossa, otathan meihin yhteyttä.
          </P>
          <ul>
            <li>
              Palvelun päivämäärävalitsinta ja monivalintojen alasvetovalikkoa ei
              ole optimoitu käytettäväksi ruudunlukijalla.
            </li>
            <li>
              Palvelun yksikkökartassa ei pysty liikkumaan
              näppäimistöllä/ruudunlukijalla, mutta yksikköjä voi selata samassa
              näkymässä olevalta listalta. Palvelussa käytetty kartta on kolmannen
              osapuolen tuottama.
            </li>
          </ul>
          <H2>Kolmannet osapuolet</H2>
          <P>
            Verkkopalvelussa käytetään seuraavia kolmannen osapuolen palveluita,
            joiden saavutettavuudesta emme voi vastata.
          </P>
          <ul>
            <li>Keycloak käyttäjän tunnistautumispalvelu</li>
            <li>Suomi.fi-tunnistautuminen</li>
            <li>Leaflet-karttapalvelu</li>
          </ul>
          <H2>Vaihtoehtoiset asiointitavat</H2>
          <P>
            <ExternalLink
              href="https://www.kauniainen.fi/varhaiskasvatus-ja-koulutus/varhaiskasvatusyksikot/kunnallinen-varhaiskasvatus/"
              text="Kauniaisten kaupungin varhaiskasvatuksen hallinto"
            />
          </P>
          <H2>Anna palautetta</H2>
          <P>
            Jos huomaat saavutettavuuspuutteen verkkopalvelussamme, kerro siitä
            meille. Voit antaa palautetta{' '}
            <ExternalLink
              href="https://www.kauniainen.fi/kaupunki-ja-paatoksenteko/osallistu-ja-vaikuta/anna-palaute/"
              text="verkkolomakkeella"
            />{' '}
            tai sähköpostitse{' '}
            <a href="https://www.kauniainen.fi/varhaiskasvatus-ja-koulutus/varhaiskasvatusyksikot/kunnallinen-varhaiskasvatus/">
            Kauniaisten kaupungin varhaiskasvatuksen hallinnon yhteystiedot</a>.
          </P>
          <H2>Valvontaviranomainen</H2>
          <P>
            Jos huomaat sivustolla saavutettavuusongelmia, anna ensin palautetta
            meille sivuston ylläpitäjille. Vastauksessa voi mennä 14 päivää. Jos et
            ole tyytyväinen saamaasi vastaukseen, tai et saa vastausta lainkaan
            kahden viikon aikana, voit antaa palautteen Etelä-Suomen
            aluehallintovirastoon. Etelä-Suomen aluehallintoviraston sivulla
            kerrotaan tarkasti, miten valituksen voi tehdä, ja miten asia
            käsitellään.
          </P>
          <P>
            <strong>Valvontaviranomaisen yhteystiedot </strong>
            <br />
            Etelä-Suomen aluehallintovirasto <br />
            Saavutettavuuden valvonnan yksikkö
            <br />
            <ExternalLink
              href="https://www.saavutettavuusvaatimukset.fi"
              text="www.saavutettavuusvaatimukset.fi"
            />
            <br />
            <a href="mailto:saavutettavuus@avi.fi">saavutettavuus@avi.fi</a>
            <br />
            puhelinnumero vaihde 0295 016 000
            <br />
            Avoinna: ma-pe klo 8.00–16.15
          </P>
        </>
      ),
    },
    sv: {
      footer: {
        cityLabel: '© Grankulla stad',
        privacyPolicyLink: (
          <a
            href="https://www.kauniainen.fi/sv/dataskydd/dataskyddsbeskrivningar-och-registerbeskrivningar/"
            data-qa="footer-policy-link"
            style={{ color: colors.main.m2 }}
          >
            Dataskyddsbeskrivningar
          </a>
        ),
        sendFeedbackLink: (
          <a
            href="https://www.kauniainen.fi/sv/smabarnspedagogik-och-utbildning/enheter-for-smabarnspedagogik/"
            data-qa="footer-feedback-link"
            style={{ color: colors.main.m2 }}
          >
            Ge feedback
          </a>
        ),
      },
      loginPage: {
        title: 'Grankulla stads småbarnspedagogik',
        login: {
          infoBoxText: (
            <>
              <P>
                {/* If you are not able to log in here, see the instructions{' '}
                <a
                  href="https://www.espoo.fi/fi/palvelut/evaka"
                  target="_blank"
                  rel="noreferrer"
                >
                  eVaka | Grankulla stad
                </a>
                . You can also log in with strong authentication. */}
              </P>
            </>
          ),
        },
      },
      map: {
        mainInfo:
          "I den här vyn kan du på kartan söka enheter med småbarnspedagogik och förskola.",
        serviceVoucherLink:
          'https://www.kauniainen.fi/sv/smabarnspedagogik-och-utbildning/enheter-for-smabarnspedagogik/privat-smabarnspedagogik/servicesedel/',
        privateUnitInfo: (
          <span>
            Privat småbarnspedagogik | Grankulla{' '}
            <ExternalLink
              text="klicka här."
              href="https://www.kauniainen.fi/sv/smabarnspedagogik-och-utbildning/enheter-for-smabarnspedagogik/privat-smabarnspedagogik/"
              newTab
            />
          </span>
        ),
      },
      applications: {
        creation: {
          preschoolLabel:
            'Anmälan till förskoleundervisning',
          preschoolDaycareInfo:
            'Med detta formulär kan du också ansöka om anslutande småbarnspedagogik för ett barn som anmäls/har anmälts till förskoleundervisning.',
          preschoolInfo: (
            <>
              <P>
                Förskoleundervisningen är gratis och ordnas fyra timmar per dag. Därtill kan du ansöka om anslutande småbarnspedagogik på samma plats,
                på morgonen före och på eftermiddagen efter förskoleundervisningen.{' '}
                <a href='https://www.kauniainen.fi/varhaiskasvatus-ja-koulutus/esiopetus/'>
                  https://www.kauniainen.fi/varhaiskasvatus-ja-koulutus/esiopetus/</a>
              </P>
            </>
          ) as unknown as string,
          applicationInfo: (
            <P>
              Du kan göra ändringar i ansökan så länge den inte har tagits upp till behandling. Därefter kan du göra ändringar i
              ansökan eller återta ansökan genom att kontakta småbarnspedagogikens servicehandledning, tfn 050 3636 343.
            </P>
          ),
          transferApplicationInfo: {
            DAYCARE:
              'Barnet har redan en plats i Grankulla stads småbarnspedagogik. Med denna ansökan kan du ansöka om byte till en annan enhet som erbjuder småbarnspedagogik.',
          },
        },
        editor: {
          unitPreference: {
            units: {
              serviceVoucherLink:
              'https://www.kauniainen.fi/sv/smabarnspedagogik-och-utbildning/enheter-for-smabarnspedagogik/privat-smabarnspedagogik/servicesedel/',
            },
          },
          heading: {
            info: {
              DAYCARE: (
                <>
                  <P>
                    Du kan ansöka om plats i småbarnspedagogisk verksamhet året om.
                    Ansökningen bör lämnas in senast fyra månader före behovet av
                    verksamheten börjar. Om behovet börjar med kortare varsel pga.
                    sysselsättning eller studier bör du ansöka om plats senast två
                    veckor före.
                  </P>
                  <P>
                    Du får ett skriftligt beslut om platsen. Beslutet delges i
                    tjänsten{' '}
                    <a
                      href="https://www.suomi.fi/meddelanden"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Suomi.fi
                    </a>
                    -meddelanden, eller per post om du inte tagit i bruk
                    meddelandetjänsten i Suomi.fi.
                  </P>
                  <P>
                    Klientavgiften inom den kommunala småbarnspedagogiken och för
                    servicesedelns självriskandel är en procentandel av familjens
                    bruttoinkomster. Utöver inkomsterna inverkar familjens storlek
                    och den överenskomna tiden i småbarnspedagogik avgiften.
                    Servicesedel enheterna kan dock ta ut tilläggspris, information
                    om eventuell tilläggspris hittas på enhetens hemsida. Familjen
                    ska lämna in en utredning över sina bruttoinkomster, senast inom
                    två veckor från det att barnet har inlett småbarnspedagogiken.
                  </P>
                  <P>
                    Mer information om småbarnspedagogikens avgifter, hur man gör
                    inkomstutredningen och servicesedelns tilläggspris hittar du
                    här:{' '}
                    <a href="https://www.kauniainen.fi/sv/smabarnspedagogik-och-utbildning/enheter-for-smabarnspedagogik/kommunal-smabarnspedagogik/avgifter/">
                      Avgifter för småbarnspedagogik
                    </a>
                    .
                  </P>
                  <P fitted={true}>
                    * Informationen markerad med en stjärna är obligatorisk
                  </P>
                </>
              ),
              PRESCHOOL: (
                <>
                  <P>
                  Barn deltar i förskoleundervisning året innan läroplikten inleds. Förskoleundervisningen är avgiftsfri. {' '}
                  <a href='https://www.kauniainen.fi/sv/smabarnspedagogik-och-utbildning/forskoleundervisning/'>https://www.kauniainen.fi/sv/smabarnspedagogik-och-utbildning/forskoleundervisning/</a>
                  </P>
                  <P>
                    Besluten kommer{' '}
                    <a
                      href="https://www.suomi.fi/meddelanden"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Suomi.fi-Meddelanden
                    </a>{' '}
                    -meddelanden, eller per post om du inte tagit i bruk
                    meddelandetjänsten i Suomi.fi.
                  </P>
                  <P fitted={true}>* Informationen markerad med en stjärna krävs</P>
                </>
              ),
            },
          },
          actions: {
            allowOtherGuardianAccess: (
              <span>
                Jag förstår att informationen om ansökan även går till barnets
                andra vårdnadshavare. Kontakta servicehandledningen vid behov.
                Kontaktuppgifterna till servicehandledningen finns här:{' '}
                <a
                  href="https://www.kauniainen.fi/sv/smabarnspedagogik-och-utbildning/enheter-for-smabarnspedagogik/kommunal-smabarnspedagogik/ansokan/"
                  target="_blank"
                  rel="noreferrer"
                >
                  här
                </a>
                .
              </span>
            ),
          },
          fee: {
            links: (
              <P>
                Mer information om småbarnspedagogikens avgifter, servicesedelns
                tilläggspris och blanketten för inkomstutredning finns här:
                <br />
                <a
                  href="https://www.kauniainen.fi/sv/smabarnspedagogik-och-utbildning/enheter-for-smabarnspedagogik/kommunal-smabarnspedagogik/avgifter/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Avgifter för småbarnspedagogik
                </a>
              </P>
            ),
          },
          contactInfo: {
            futureAddressInfo:
              'Grankulla småbarnspedagogik betraktar adressen i befolkningsdatabasen som den officiella adressen. Adressen ändras i befolkningsregistret när du gör en flyttanmälan till posten eller magistraten.',
          },
          serviceNeed: {
            startDate: {
              info: {
                PRESCHOOL: [
                  'Den finsk- och den svenskspråkiga förskoleundervisningen börjar 7.8.2025'
                ],
              },
              instructions: {
                DAYCARE: (
                  <>
                    Det är möjligt att senarelägga det önskade startdatumet så länge
                    ansökan inte har tagits upp till behandling. Därefter kan du
                    ändra det önskade startdatumet genom att kontakta
                    servicehandledningen inom småbarnspedagogik (tfn 050 3636 343).
                  </>
                ),
                PRESCHOOL: (
                  <>
                    Det är möjligt att senarelägga det önskade startdatumet så länge
                    ansökan inte har tagits upp till behandling. Därefter kan du
                    ändra det önskade startdatumet genom att kontakta
                    servicehandledningen inom småbarnspedagogik (tfn 050 3636 343).
                  </>
                ),
                CLUB: null
              },
            },
            urgent: {
              attachmentsMessage: {
                text: (
                  <>
                    <P fitted={true}>
                      Om behovet av en plats inom småbarnspedagogiken beror på att du
                      plötsligt fått sysselsättning eller börjat studera, ska platsen
                      sökas senast <strong>två veckor innan</strong> behovet börjar.
                      Bifoga till ansökan ett arbets- eller studieintyg av båda
                      vårdnadshavarna som bor i samma hushåll. Om du inte kan lägga
                      till bilagor till ansökan elektroniskt, skicka dem per s-post till
                      kauniainen@kauniainen.fi. Behandlingstiden på två veckor börjar när vi
                      har tagit emot ansökan och bilagorna som behövs.
                    </P>
                    <P>
                    Vårdbehovet gäller tiden i småbarnspedagogiken och reserveras varje vecka. Meddela det önskade vårdbehovet i småbarnspedagogiken under "Övriga tilläggsuppgifter" och välj en av dessa:
                      <ul>
                        <li>
                          högst 25 timmar i veckan
                        </li>
                        <li>
                          25-35 timmar i veckan
                        </li>
                        <li>
                          över 35 timmar i veckan
                        </li>
                      </ul>
                    </P>
                  </>
                ),
              }
            },
          },
        },
      },
      accessibilityStatement: (
        <>
          <H1>Tillgänglighetsutlåtande</H1>
          <P>
            Detta tillgänglighetsutlåtande gäller Grankulla stads webbtjänst eVaka för
            småbarnspedagogiken på adressen{' '}
            <a href="https://evaka.kauniainen.fi">evaka.kauniainen.fi</a>.
            Grankulla stad strävar efter att säkerställa webbtjänstens tillgänglighet,
            kontinuerligt förbättra användarupplevelsen och att tillämpa lämpliga
            tillgänglighetsstandarder.
          </P>
          <P>
            Tjänstens tillgänglighet har bedömts av tjänsteutvecklingsteamet, och
            utlåtandet har utarbetats den 12 april 2022.
          </P>
          <H2>Tjänstens överensstämmelse med krav</H2>
          <P>
            Webbtjänsten uppfyller de lagstadgade kritiska tillgänglighetskraven
            enligt nivå AA i WCAG 2.1. Tjänsten uppfyller ännu inte alla krav.
          </P>
          <H2>Åtgärder för att stödja tillgängligheten</H2>
          <P>
            Webbtjänstens tillgänglighet säkerställs bland annat genom följande
            åtgärder:
          </P>
          <ul>
            <li>
              Tillgängligheten beaktas redan från början i planeringsfasen till
              exempel genom att välja färgerna och fontstorleken i tjänsten med
              tillgängligheten i åtanke.
            </li>
            <li>Elementen i tjänsten har definierats semantiskt konsekvent.</li>
            <li>Tjänsten testas ständigt med en skärmläsare.</li>
            <li>
              Olika användare testar tjänsten och ger respons på tillgängligheten.
            </li>
            <li>
              Webbplatsens tillgänglighet säkerställs genom kontinuerliga kontroller
              vid tekniska eller innehållsmässiga förändringar.
            </li>
          </ul>
          <P>
            Detta utlåtande uppdateras när webbplatsen ändras eller tillgängligheten
            justeras.
          </P>
          <H2>Kända tillgänglighetsproblem</H2>
          <P>
            Användare kan fortfarande stöta på vissa problem på webbplatsen. Nedan
            följer beskrivningar av kända tillgänglighetsproblem. Om du upptäcker
            ett problem som inte finns med på listan, vänligen kontakta oss.
          </P>
          <ul>
            <li>
              Tjänstens datum- och flervalsfält är inte optimerade för att användas
              med skärmläsare
            </li>
            <li>
              Det går inte att navigera på serviceenhetskartan med
              tangentbordet/skärmläsaren, men man kan bläddra bland enheterna på
              listan i samma vy. Kartan som används i tjänsten är framtagen av en
              tredje part.
            </li>
          </ul>
          <H2>Tredje parter</H2>
          <P>
            Webbtjänsten använder följande tredjepartstjänster, vars tillgänglighet
            vi inte är ansvariga för.
          </P>
          <ul>
            <li>Användarautentiseringstjänsten Keycloak</li>
            <li>Tjänsten suomi.fi</li>
            <li>Karttjänsten Leaflet</li>
          </ul>
          <H2>Alternativa sätt att sköta ärenden</H2>
          <P>
            <ExternalLink
              href="https://www.kauniainen.fi/sv/smabarnspedagogik-och-utbildning/enheter-for-smabarnspedagogik/kommunal-smabarnspedagogik/"
              text="Grankulla stads servicepunkter"
            />{' '}
            hjälper till med användningen av e-tjänsterna. Rådgivarna vid
            servicepunkterna hjälper de användare, för vilka de digitala tjänsterna
            inte är tillgängliga.
          </P>
          <H2>Ge respons</H2>
          <P>
            er en tillgänglighetsbrist i vår webbtjänst, vänligen meddela oss. Du
            kan ge respons med{' '}
            <ExternalLink
              href="https://www.kauniainen.fi/sv/staden-och-beslutsfattande/delta-och-paverka/respons/"
              text="webformuläret"
            />{' '}
            eller via e-post{' '}
            <a href="mailto:kauniainen@kauniainen.fi">kauniainen@kauniainen.fi</a>.
          </P>
          <H2>Tillsynsmyndighet</H2>
          <P>
            Om du upptäcker tillgänglighetsproblem på webbplatsen, ge först respons
            till oss, webbplatsens administratörer. Det kan ta upp till 14 dagar
            tills du får ett svar från oss. Om du inte är nöjd med det svar du har
            fått eller om du inte alls har fått något svar inom två veckor, kan du
            ge respons till Regionförvaltningsverket i Södra Finland. På
            regionförvaltningsverkets webbplats finns information om hur du kan
            lämna in ett klagomål samt om hur ärendet handläggs.
          </P>
          <P>
            <strong>Kontaktuppgifter till tillsynsmyndigheten</strong>
            <br />
            Regionförvaltningsverket i Södra Finland
            <br />
            Enheten för tillgänglighetstillsyn
            <br />
            <ExternalLink
              href="https://www.tillganglighetskrav.fi"
              text="www.tillganglighetskrav.fi"
            />
            <br />
            <a href="mailto:saavutettavuus@avi.fi">saavutettavuus@avi.fi</a>
            <br />
            telefonnummer till växeln 0295 016 000
            <br />
            Öppet mån.– fre. kl. 8.00–16.15
          </P>
        </>
      ),
    },
    en: {
      header: {
        lang: {
          fi: 'Suomeksi',
          sv: '',
          en: 'In English'
        },
        langMobile: {
          fi: 'Suomeksi',
          sv: '',
          en: 'English'
        },
      },
      footer: {
        cityLabel: '© City of Kauniainen',
        privacyPolicyLink: (
          <a
            href="https://www.kauniainen.fi/tietosuoja/tietosuojaselosteet-ja-rekisteriselosteet/"
            data-qa="footer-policy-link"
            style={{ color: colors.main.m2 }}
          >
            Privacy notices
          </a>
        ),
        sendFeedbackLink: (
          <a
            href="https://www.kauniainen.fi/en/education-and-daycare/early-childhood-education-units/"
            data-qa="footer-feedback-link"
            style={{ color: colors.main.m2 }}
          >
            Give feedback
          </a>
        ),
      },
      loginPage: {
        title: 'City of Kauniainen early childhood education',
        login: {
          infoBoxText: (
            <>
              <P>
                {/* If you are not able to log in here, see the instructions{' '}
                <a
                  href="https://www.espoo.fi/fi/palvelut/evaka"
                  target="_blank"
                  rel="noreferrer"
                >
                  eVaka | Kauniaisten kaupunki
                </a>
                . You can also log in with strong authentication. */}
              </P>
            </>
          ),
        },
      },
      map: {
        mainInfo:
          "In this view, you can search the map for Kauniainen's early childhood education, pre-primary education and club places.",
      },
      applications: {
        creation: {
          preschoolLabel:
            'Enrolment to pre-primary education',
          preschoolDaycareInfo:
          'With this form, you can also apply for connected early childhood education for a child who will be / has been enrolled in pre-primary education.',
          preschoolInfo:
            'Free pre-primary education is provided for four hours a day. In addition, you can apply for supplementary early childhood education, which is offered at pre-primary education locations in the mornings before the start of pre-primary education and in the afternoons after the end of pre-primary education.',
          transferApplicationInfo: {
            DAYCARE:
              "Your child already has a place in the City of Kauniainen's early childhood education. Use this application to apply for a transfer to another early childhood education unit.",
          },
          applicationInfo: (
            <P>
              You can make changes to your application until its processing starts.
              After that you can make changes to your application or cancel the application by contacting the early
              childhood education service counseling by phone, 050 3636 343.
            </P>
          )
        },
        editor: {
          unitPreference: {
            units: {
              serviceVoucherLink:
              'https://www.kauniainen.fi/sv/smabarnspedagogik-och-utbildning/enheter-for-smabarnspedagogik/privat-smabarnspedagogik/servicesedel/',
            },
          },
          heading: {
            info: {
              DAYCARE: (
                <>
                  <P>
                    You can apply for early childhood education all year round. The
                    application must be submitted at the latest four months before
                    the need for early childhood education begins. If you urgently
                    need early childhood education, you must apply for a place at
                    the latest two weeks before the need begins.
                  </P>
                  <P>
                    The applicant will receive a written decision on the early
                    childhood education place via the{' '}
                    <a
                      href="https://www.suomi.fi/messages"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Messages service of Suomi.fi
                    </a>{' '}
                    or by post if the applicant has not taken in use the Messages
                    service of Suomi.fi.
                  </P>
                  <P>
                    The client fees for municipal early childhood education and the
                    client charges for service voucher users are calculated as a
                    percentage of the family’s gross income. The fees vary depending
                    on the family’s size and the hours of early childhood education.
                    Service voucher units may charge an additional monthly fee,
                    information of the possible additional fee can be found from
                    units own website. Each family must provide information about
                    their gross income, no later than two weeks after their child’s
                    early childhood education has started.
                  </P>
                  <P>
                    For more information on early childhood education and care fees,
                    how to submit a performance report and the service voucher surcharge, click here:
                    <a href="https://www.kauniainen.fi/varhaiskasvatus-ja-koulutus/varhaiskasvatusyksikot/kunnallinen-varhaiskasvatus/maksut/">
                    early childhood education and care fees
                    </a>
                    .
                  </P>
                  <P fitted={true}>* Tähdellä merkityt tiedot ovat pakollisia</P>
                </>
              ),
              PRESCHOOL: (
                <>
                  <P>
                  Pre-school education is attended in the year before compulsory education. {' '}
                  Pre-school education is free of charge. For more information: {' '}
                  <a href=' https://www.kauniainen.fi/varhaiskasvatus-ja-koulutus/esiopetus/'>
                  https://www.kauniainen.fi/varhaiskasvatus-ja-koulutus/esiopetus/</a>
                  </P>
                  <P>
                    The decisions will be sent to the{' '}
                    <a
                    href="https://www.suomi.fi/messages"
                    target="_blank"
                    rel="noreferrer"
                    >
                      Suomi.fi Messages
                    </a>{' '}
                      service or by post, if the applicant does not use the{' '}
                    <a
                      href="https://www.suomi.fi/messages"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Suomi.fi Messages
                    </a>{' '}
                    service.
                  </P>
                  <P fitted={true}>* Information marked with a star is required</P>
                </>
              ),
              CLUB: (
                <>
                  <P>
                    Applications for playgroup activities are made electronically with an application form
                    for early childhood education. In the application form, you select part-day care as the
                    type of care and write in the additional information that you are applying for playgroup activities.
                  </P>
                  <P>
                    The playgroup fee is 17% of the Early Childhood Education and Care fee,
                    which is calculated from family’s income and size.
                  </P>
                  <P>
                    Playgroup activities are active from September to the end of May.
                    Kids can attend Playgroup activities from the begining of the month in which the child turns 3 years old.
                  </P>
                  <P fitted={true}>* Information marked with an asterisk is required</P>
                </>
              )
            },
          },
          actions: {
            allowOtherGuardianAccess: (
              <span>
                I understand that the application will also be visible to the other
                guardian. Please contact the Early Childhood Education Service
                Guidance if necessary, whose contact information can be found{' '}
                <a
                  href="https://www.kauniainen.fi/varhaiskasvatus-ja-koulutus/varhaiskasvatusyksikot/kunnallinen-varhaiskasvatus/hakeminen/"
                  target="_blank"
                  rel="noreferrer"
                >
                  here
                </a>
                .
              </span>
            ),
          },
          serviceNeed: {
            startDate: {
              info: {
                PRESCHOOL: [
                  'Pre-primary education starts 7.8.2025',
                ],
              },
            },
            urgent: {
              attachmentsMessage: {
                text: (
                  <P fitted={true}>
                    If the need for a place in early childhood education arises from
                    sudden employment or a sudden start of studies, you will need to
                    apply for a place no later than{' '}
                    <strong>two weeks before</strong> your child needs it. In
                    addition to the application, you will need to{' '}
                    <strong>
                      provide documents as proof of the employment or student status
                    </strong>{' '}
                    of both guardians living in the same household.
                    If you cannot add attachments to the application electronically,
                    please send them by post to City of Kauniainen Early Childhood Education Service Guidance, PL 1, 02701 Kauniainen.
                  </P>
                ),
              }
            },
            dailyTime: {
              connectedDaycareInfo: (
                <>
                  <P>
                    If necessary, you can apply for additional early childhood education
                    for your child in addition to pre-school education, which is subject to a fee.
                    Additional early childhood education is provided in the mornings before pre-school
                    and after pre-school according to the opening hours of the day-care center.
                  </P>
                  <P>
                    A separate written decision will be issued on the early
                    childhood education place. The decision will be sent to the{' '}
                    <a
                      href="https://www.suomi.fi/messages"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Suomi.fi Messages
                    </a>{' '}
                    service or by post if you do not use the{' '}
                    <a
                      href="https://www.suomi.fi/messages"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Suomi.fi messages
                    </a>{' '}
                    service.
                  </P>
                </>
              ),
            },
          },
          fee: {
            links: (
              <>
              <P>
                You can find further information about early childhood education
                fees, additional fees for service voucher users and the income
                statement form here:
                <br />
                <a
                  href="https://www.kauniainen.fi/varhaiskasvatus-ja-koulutus/varhaiskasvatusyksikot/kunnallinen-varhaiskasvatus/maksut/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Early childhood education fees
                </a>
              </P>
              <P>
                <a
                  href="https://www.kauniainen.fi/varhaiskasvatus-ja-koulutus/varhaiskasvatusyksikot/yksityinen-varhaiskasvatus/palveluseteli/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Additional fees for service voucher users
                </a>
              </P>
              </>
            )
          },
          contactInfo: {
            futureAddressInfo:
              "Kauniainen's early childhood education considers the address retrieved from the Population Register Centre as the official address. The address in the Population Register Centre changes when the applicant makes a notification of move to Posti or the Local Register Office.",
          },
        },
      },
      income: {
        description: (
          <>
           <P>
             On this page, you can submit statements on your and your
             children&apos;s earnings that affect the early childhood education
             fee. You can also view, edit, or delete income statements that you
             have submitted until the authority has processed the information.
             After the form has been processed, you can update your income
             information by submitting a new form.
           </P>
           <P>
             The client fees for municipal early childhood education are determined
             as a percentage of the family’s gross income. The fees vary according
             to family size, income and time in early childhood education.
             For the purposes of determining the fee,
             the family's informations of incomes must be submitted within two weeks
             of the start of the early childhood education and care.
             If the family fails to provide income information, the maximum fee will be imposed.
           </P>
           <P>
             More information on the fees:{' '}
             <a href="https://www.kauniainen.fi/varhaiskasvatus-ja-koulutus/varhaiskasvatusyksikot/kunnallinen-varhaiskasvatus/maksut/">
               Early childhood education fees
             </a>
           </P>
         </>
        ),
        formDescription: (
          <>
            <P>
              The early childhood education and care fee is a fixed monthly fee based on
              the family's income and the number of family members.
              For the purpose of determining the fee, a family is defined as persons living
              in a common household in a married or unmarried state, and minor children of
              both persons living in the same household.
            </P>
            <P>
              For more information on the fees: {' '}
              <a
                target="_blank"
                rel="noreferrer"
                href="https://www.kauniainen.fi/varhaiskasvatus-ja-koulutus/varhaiskasvatusyksikot/kunnallinen-varhaiskasvatus/maksut/"
              >
                here
              </a>
              .
            </P>
            <P>* The information denoted with an asterisk is mandatory.</P>

          </>
        ),
        assure: <>I confirm that the information I have provided is correct. *</>,
      },
      accessibilityStatement: (
        <>
          <H1>Accessibility statement</H1>
          <P>
            This accessibility statement applies to the City of Kauniainen's early
            childhood education online service eVaka at{' '}
            <a href="https://evaka.kauniainen.fi">evaka.kauniainen.fi</a>.
            The City of Kauniainen endeavours to ensure the accessibility of the online
            service, continuously improve the user experience and apply appropriate
            accessibility standards.
          </P>
          <P>
            The accessibility of the service was assessed by the development team of
            the service, and this statement was drawn up on 12 April 2022.
          </P>
          <H2>Compliance of the service</H2>
          <P>
            The online service complies with the statutory critical accessibility
            requirements in accordance with Level AA of the Accessibility Guidelines
            for the WCAG v2.1. The service is not yet fully compliant with the
            requirements.
          </P>
          <H2>Measures to support accessibility</H2>
          <P>
            The accessibility of the online service is ensured, among other things,
            by the following measures:
          </P>
          <ul>
            <li>
              Accessibility has been taken into account from the beginning of the
              design phase, for example, when choosing the colours and font sizes of
              the service.
            </li>
            <li>
              The service elements have been defined in consistently in terms of
              semantics.
            </li>
            <li>The service is continuously tested with a screen reader.</li>
            <li>
              Various users test the service and give feedback on its accessibility.
            </li>
            <li>
              When website technology or content changes, its accessibility is
              ensured through constant monitoring.
            </li>
          </ul>
          <P>
            This statement will be updated in conjunction with website changes and
            accessibility evaluations.
          </P>
          <H2>Known accessibility issues</H2>
          <P>
            Users may still encounter some issues on the website. The following
            contains a description of known accessibility issues. If you notice an
            issue on the site that is not listed, please contact us.
          </P>
          <ul>
            <li>
              Date pickers and multi-select dropdowns in the service are not
              optimised to be used with a screen reader.
            </li>
            <li>
              The service's unit map cannot be navigated using the keyboard/screen
              reader, but the units can be browsed on the list available in the same
              view. The map used in the service is produced by a third party.
            </li>
          </ul>
          <H2>Third parties</H2>
          <P>
            The online service uses the following third party services, the
            accessibility of which we cannot be responsible for.
          </P>
          <ul>
            <li>Keycloak user identification service</li>
            <li>Suomi.fi identification</li>
            <li>Leaflet map service</li>
          </ul>
          <H2>Alternative ways of accessing the service</H2>
          <P>
            <ExternalLink
              href="https://www.kauniainen.fi/varhaiskasvatus-ja-koulutus/varhaiskasvatusyksikot/kunnallinen-varhaiskasvatus/"
              text="The City of Kauniainen’s Service Points"
            />{' '}
            provide assistance with using electronic services. Service advisors at
            the Service Points help users who cannot access digital services.
          </P>
          <H2>Give feedback</H2>
          <P>
            If you notice an accessibility gap in our online service, please let us
            know! You can give us feedback using the{' '}
            <ExternalLink
              href="https://www.kauniainen.fi/kaupunki-ja-paatoksenteko/osallistu-ja-vaikuta/anna-palaute/"
              text="online form"
            />{' '}
            or by emailing{' '}
            <a href="mailto:kauniainen@kauniainen.fi">kauniainen@kauniainen.fi</a>.
          </P>
          <H2>Supervisory authority</H2>
          <P>
            If you notice any accessibility issues on the website, please send us,
            the site administrator, feedback first. It may take us up to 14 days to
            reply. If you are not satisfied with the reply or you do not receive a
            reply within two weeks, you can give feedback to the Regional State
            Administrative Agency for Southern Finland. The website of the Regional
            State Administrative Agency for Southern Finland explains in detail how
            a complaint can be submitted, and how the matter will be processed.
          </P>
          <P>
            <strong>Contact information of the supervisory authority</strong>
            <br />
            Regional State Administrative Agency of Southern Finland
            <br />
            Accessibility Supervision Unit
            <br />
            <ExternalLink
              href="https://www.saavutettavuusvaatimukset.fi"
              text="www.saavutettavuusvaatimukset.fi"
            />
            <br />
            <a href="mailto:saavutettavuus@avi.fi">saavutettavuus@avi.fi</a>
            <br />
            tel. (exchange) 0295 016 000
            <br />
            Open: Mon-Fri 8.00–16.15
          </P>
        </>
      ),
    },
  },
  cityLogo: {
    src: MunicipalityLogo,
    alt: 'Kauniainen logo',
  },
  routeLinkRootUrl: 'https://reittiopas.hsl.fi/reitti/',
  mapConfig,
  featureFlags,
  getMaxPreferredUnits() {
    return 3
  },
}

export default customizations
